module.exports = __webpack_public_path__ + "img/logo1.824a0ac0.png";